import { useEffect, useState } from 'react';

const MINUTO = 60_000;

/**
 * Instante atual que muda na virada de cada minuto: para textos relativos ("em 38 min") não
 * envelhecerem na tela sem renderizar a cada segundo.
 */
export function useAgoraPorMinuto(): number {
  const [agora, setAgora] = useState(() => Date.now());
  useEffect(() => {
    const timer = setTimeout(
      () => {
        setAgora(Date.now());
      },
      MINUTO - (agora % MINUTO),
    );
    return () => {
      clearTimeout(timer);
    };
  }, [agora]);
  return agora;
}
